import "./registerServiceWorker";
import { startAgeGate } from "@/lib/ageGate";
import { installChunkLoadErrorHandler } from "@/lib/chunkLoad";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { setPWAPrompt } from "@/lib/pwa";
import { detectWebpSupport } from "@/lib/webpSupport";
import { applyPolyfills } from "@/modules/polyfills";
import createApp from "@/main";

installChunkLoadErrorHandler();
setPWAPrompt();

// thumbnail URLs are built at render time, so the format must be known before the first mount
const enableWebpThumbnails = detectWebpSupport().then(supported => {
  if (supported) MediaFilesController.setThumbnailFormat("webp");
});

Promise.all([applyPolyfills(), enableWebpThumbnails])
  .then(() => createApp())
  .then(({ app }) => {
    // the config is loaded by now; the gate covers the page before the app is mounted
    startAgeGate();
    app.$mount("#app");
  });
